import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { updateLoanOfferStatusApi } from '../../apis/loan';
import { handleApiError } from '../../helpers';
import { LoanOffer, LoanOfferStatus, LoanStatusId, UpdateLoanOfferStatusDto } from '../../interfaces';
import { UpdateLoanDisbursementChecker, updateLoanOffer, updateLoanStatus } from '../../states/action_creators/loan.action_creator';
import useToggle from '../useToggle';

export const useUpdateLoanOfferStatus = (offer: LoanOffer, status: LoanOfferStatus) => {
  const [updating, setUpdating] = useState(false);
  const { show: showForm, toggle: toggleForm } = useToggle();

  const dispatch = useDispatch();

  const onSubmitHandler = async (payload: UpdateLoanOfferStatusDto) => {
    setUpdating(true);
    try {
      payload.status = status;

      const response = await updateLoanOfferStatusApi(payload, offer.id);
      const updatedOffer: LoanOffer = response.data;
      updatedOffer.user = offer.user;
      dispatch(updateLoanOffer(updatedOffer));

      // if the borrower accepted the offer, make the loan status underwriting
      if (status === LoanOfferStatus.ACCEPTED) {
        dispatch(updateLoanStatus(LoanStatusId.UNDERWRITING));
      }

      // if the offer is cancelled or decline, make the loan open again
      if (status === LoanOfferStatus.CANCELLED || status === LoanOfferStatus.DECLINED) {
        dispatch(updateLoanStatus(LoanStatusId.OPEN));
        dispatch(UpdateLoanDisbursementChecker(false));
      }

      setUpdating(false);
      toggleForm();
      toast.success('We have succesfully saved your request');
    } catch (error) {
      toast.error(handleApiError(error));
      setUpdating(false);
    }
  };

  return {
    onSubmitHandler,
    updating,
    showForm,
    toggleForm,
  };
};
